export default "__VITE_ASSET__DTx1i1tn__"